module.exports = __webpack_public_path__ + "static/img/icon-eps_filled.78c1a9d0.svg";